export enum GerenciamentoDocumentoSituacao {
    PendenteLiberacao = 'pendente_liberacao',
    PendenteAssinatura = 'pendente_assinatura',
    Assinado = 'assinado',
    Entregue = 'entregue',
    AssinaturaCancelada = 'assinatura_cancelada'
}

export interface IGerenciamentoDocumentoHistoricoAPI {
    arquivotrabalhadorhistorico: string;
    tenant: number;
    arquivotrabalhador: string;
    created_at: string;
    created_by: {
        nome: string;
        email: string;
    };
    lastupdate: string;
    acao: string;
    mensagem: string;
    full_count: number;
}

export interface IGerenciamentoDocumentoHistorico {
    id: string;
    titulo: string;
    dataHora: string;
    descricao: string;
    responsavel?: string;
    categoria?: 'falha' | 'manual' | 'sistema';
}

export interface IExclusaoLoteResultado {
    excluidos: string[];
    erros: {
        documento: string;
        motivo: string;
    }[];
}

export interface ITrabalhador {
    id: string;
    nome: string;
    email: string;
    codigo: string;
}

export interface IGerenciamentoDocumentoCamposCustomizados {
    [key: string]: string | null | undefined;
}

export interface IGerenciamentoDocumento {
    arquivotrabalhador: string;
    competenciaano: string | null;
    competenciames: string | null;
    created_at: string | null;
    created_by: { nome: string; email: string; } | null;
    data_assinatura?: string | null;
    data_cancelamento?: string | null;
    dataliberacao: string;
    datasolicitacaoassinatura?: string | null;
    datarecebimento: string;
    datavisualizacao: string;
    deleted_at: string | null;
    deleted_by: { nome: string; email: string; } | null;
    excluido: boolean;
    extensao: string;
    full_count: number;
    lastupdate: string;
    nome: string;
    origem: number;
    patharquivo: string;
    prazoassinatura?: number | string | null;
    situacaoassinatura: number;
    situacaoliberacao: boolean;
    situacaovisualizado: boolean;
    solicitacao: string;
    tenant: number;
    tipoarquivo: {
        tipoarquivo: string;
        tenant: number;
        codigo: string;
        titulo?: string;
        descricao?: string;
        nome?: string;
    };
    campos_customizados?: IGerenciamentoDocumentoCamposCustomizados;
    trabalhador: ITrabalhador;
    id?: string;
    disableCheckbox?: boolean;
    rowcustomclass?: string;
    historico?: Array<any>;
    trabalhadorDisplay?: string;
    tipoarquivoTitulo?: string;
    nomeDocumentoDisplay?: string;
    referencia?: string;
    situacaoAtualLabel?: string;
    situacaoAtual?: GerenciamentoDocumentoSituacao;
    matricula?: string;
    datageracao?: string;
    dataassinaturaDisplay?: string;
    prazoassinaturaDisplay?: string;
    datacancelamentoDisplay?: string;
    situacaoClasse?: string;
}
